<template>
  <div class="header-style">
    <i :class="icon" style="font-size: 25px;color: white;line-height: 60px;cursor: pointer;" @click="collapse"></i>
    <div style="flex: 1;text-align: center;">
      <span style="color: white;font-size: 25px;">欢迎来到网站后台管理系统</span>
    </div>
    <el-dropdown>
      <span style="color: white;">{{ user.name }}</span>
      <i class="el-icon-arrow-down" style="margin-left: 5px;color: white;"></i>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item @click.native="toUser">个人中心</el-dropdown-item>
        <el-dropdown-item @click.native="logout">退出登录</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
export default {
  name: "Header",
  props: {
    icon: String
  },
  data() {
    return {
      user: JSON.parse(sessionStorage.getItem('CurUser')),
    }
  },
  created() {
    this.$router.push('/home');
  },
  methods: {
    toUser() {
      this.$router.push('/home');
    },
    logout() {
      this.$confirm('您确定要退出登录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        this.utils.showMessage("success", "退出成功");
        sessionStorage.clear();
        this.$router.push('/');
      }).catch(() => {
      });
    },
    collapse() {
      this.$emit("doCollapse");
    }
  }
}
</script>

<style scoped>

.header-style {
  display: flex;
}

</style>